import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type TestimonialCtaProps = CtaShellProps

export function TestimonialCta(props: TestimonialCtaProps) {
  return <CtaShell {...props} layout="split" socialProof={props.socialProof ?? { quote: { body: "This was the first generated page that felt like a designer had already fought for the details.", name: "Mara Chen", role: "VP Growth" } }} />
}
